<iw-details-value
  label="withdrawal.paypal.email.label"
  [value]="details.email"
/>
